import React, { useEffect } from 'react';
import clsx from 'clsx';
import { useSearchParams } from 'react-router-dom';
import TransactionHistoryTable from './TransactionHistoryTable';
// import TransactionHistoryChart from './TransactionHistoryChart';

import styles from './styles.module.scss';

const FCEExplorer = (props) => {
  const { className, style, forceReload, setForceReload } = props;
  const [searchParams] = useSearchParams();

  useEffect(() => {
    console.log(`FCEExplorer: forceReload: ${forceReload}`);
  }, [forceReload]);

  return (
    <div className={clsx(styles.Explorer, 'Explorer', className)} style={{ ...style }}>
      <div className={clsx(styles.row3, 'row3')}>
        <div style={{ overflow: 'auto' }}>
          <TransactionHistoryTable
            forceReload={forceReload}
            setForceReload={setForceReload}
            hashFromUrl={searchParams.get('hash')}
          />
        </div>
      </div>
    </div>
  );
};

export default FCEExplorer;
